import "./Modal.scss";

export default function Modal({ isOpen, modalCallback, className, children , modalDialogClassName, widthProp , DarkColorMode}) {
  function onCloseHandler() {
    modalCallback({ isOpen: false });
  }

  return isOpen ? (
    <div
      className={
        className === undefined ? "modal show" : `modal show ${className}`
      }
    >
      <div className="modal-outside" onClick={onCloseHandler}></div>
      <div
          // className="modal-dialog modal-fullscreen"
          className={
            modalDialogClassName === undefined ? "modal-dialog" : `modal-dialog  ${modalDialogClassName}`
          }
          style={ widthProp ===undefined ? {'minWidth':'65vw'} :  {'minWidth':widthProp}}

              >
        <div className={`modal-content ${DarkColorMode === "ON" ? "dark-color-mode" : ""}`}>
          <button
            type="button"
            className="btn-close"
            onClick={onCloseHandler}
          ></button>
          {children}
        </div>
      </div>
    </div>
  ) : null;
}
